































































import {
	computed,
	defineComponent,
	PropType,
	watch,
} from '@vue/composition-api';
import deepEqual from 'deep-equal';
import { trackGroupSimpleAction } from '@front-app/services/ActionApi/ActionApi';
import { GroupAuditAction } from '@front-app/services/ActionApi/ActionModel';
import { Size } from '@front-app/components/constants';
import { UserAvatarStore } from '@front-app/store/singletons/User';
import { Content } from '@front-app/services/GroupsApi/DiscussionModel';
import { NoteMeta } from '@front-app/services/NoteApi/NoteModels';
import MailIcon from '@front-app/components/icons-old/Mail.vue';
import UserAvatar from '@front-app/components/user/avatar.vue';
import TrButton from '@front-app/components/buttons/TrButton.vue';
import SimpleCard from '../cards/SimpleCard.vue';
import LoaderState from '../LoaderState.vue';
import NoteContextHeader from './NoteContextHeader.vue';
import NoteButton from '../buttons/NoteButton.vue';

export default defineComponent({
	components: {
		MailIcon,
		SimpleCard,
		UserAvatar,
		LoaderState,
		NoteContextHeader,
		NoteButton,
	},
	props: {
		isLoading: Boolean,
		allMetadata: {
			type: Array as PropType<NoteMeta[]>,
			required: true,
		},
		discussion: {
			type: Object as PropType<Content>,
			required: true,
		},
	},
	setup(props) {
		const trackActionProps = computed(() => props.discussion.groupId);
		watch(trackActionProps, (curr, prev) => {
			if (deepEqual(curr, prev) || !props.discussion.groupId) {
				return;
			}
			trackGroupSimpleAction(props.discussion.groupId, GroupAuditAction.VIEW_NOTE_LIST_PAGE);
		}, { immediate: true });
		return {
			TrButton,
			Size,
			getAvatar: UserAvatarStore.get,
			fetchAvatar: UserAvatarStore.fetch,
		};
	},
});
